"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var Datatable_1 = require("./Datatable");

var react_redux_1 = require("react-redux");

var autobind_decorator_1 = __importDefault(require("autobind-decorator"));

var classnames_1 = __importDefault(require("classnames"));

var styles = function styles(t) {
  return core_1.createStyles({
    root: {
      transition: t.transitions.create('all'),
      opacity: 0,
      transform: 'translate(0, 60px)'
    },
    root_appeared: {
      opacity: 1,
      transform: 'translateY(0)'
    },
    expend: {
      // margin: `-1px -${t.spacing.unit}px`,
      background: t.palette.background.paper
    },
    row: {
      '& > td:first-child': {
        borderLeft: "2px solid " + t.palette.primary.main
      }
    },
    cell: {
      borderLeft: "2px solid " + t.palette.primary.main
    }
  });
};

var DatatableRow =
/** @class */
function (_super) {
  __extends(DatatableRow, _super);

  function DatatableRow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      appeared: false
    };
    return _this;
  }

  DatatableRow.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        expendedRow = _a.expendedRow,
        classes = _a.classes;
    var onClick = expendedRow ? {
      onClick: this.toggle
    } : {};
    return React.createElement(React.Fragment, null, React.createElement(core_1.TableRow, __assign({
      hover: true
    }, onClick, {
      className: classnames_1.default(classes.root, this.state.appeared && classes.root_appeared, this.isExpended() ? classes.row : '')
    }), children), this.isExpended() && React.createElement(core_1.TableRow, null, React.createElement(core_1.TableCell, {
      colSpan: 100,
      className: classes.cell
    }, React.createElement(core_1.CardContent, null, expendedRow), React.createElement(core_1.CardActions, null, React.createElement(core_1.Button, {
      color: "primary",
      variant: "outlined",
      onClick: this.toggle
    }, "Close")))));
  };

  DatatableRow.prototype.componentDidMount = function () {
    var _this = this;

    var index = this.props.index;
    this.timeout = setTimeout(function () {
      return _this.setState({
        appeared: true
      });
    }, index * 30);
  };

  DatatableRow.prototype.componentWillUnmount = function () {
    clearTimeout(this.timeout);
  };

  DatatableRow.prototype.isExpended = function () {
    var _a = this.props,
        index = _a.index,
        expendedRowIndex = _a.expendedRowIndex;
    return index === expendedRowIndex;
  };

  DatatableRow.prototype.toggle = function () {
    var _a = this.props,
        index = _a.index,
        expendRow = _a.expendRow;
    expendRow(index);
  };

  __decorate([autobind_decorator_1.default], DatatableRow.prototype, "toggle", null);

  return DatatableRow;
}(React.Component);

var state2props = function state2props(state, ownProps) {
  var paginateState = state.paginate[ownProps.name];
  return {
    criteria: paginateState.criteria,
    data: paginateState.entities
  };
};

exports.default = Datatable_1.datatableConsumer(core_1.withStyles(styles)(react_redux_1.connect(state2props)(DatatableRow))); //
// export default compose(
//   datatableConsumer,
//   connect(state2props),
//   withStyles(styles),
// )(DatatableRow)